module.exports = __webpack_public_path__ + "static/media/arrow-right-v2.f7458ca4.svg";